import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { browserHistory } from 'react-router'
import { isValidSouthAfricanIDNumber } from 'validator-sa'

let FindUser = ({ handleSubmit, pristine, submitting, invalid }) => (<form onSubmit={handleSubmit}>
  <div className='form-group'>
    <label>Find User by ID number</label>
    <Field component='input' type='text'
      placeholder='ID number...'
      name='search' className='form-control' required/>
  </div>
  <button
    type="submit"
    className="btn btn-success btn-block" disabled={pristine || submitting || invalid}>
    Find User
  </button>
</form>)

FindUser = reduxForm({
  form: 'findUser',
  validate: values => {
    const errors = {}
    if (values.search && !isValidSouthAfricanIDNumber(values.search)) {
      errors.search = 'Invalid ID number'
    }
    return errors
  },
  onSubmit: (values, dispatch) => browserHistory.push(`/view-as-admin/${ values.search }`)
})(FindUser)

export default FindUser



// WEBPACK FOOTER //
// ./src/app/components/find-user.js